module.exports = __webpack_public_path__ + "static/media/ipadpro1_splash.8a200d91.png";